// extracted by mini-css-extract-plugin
export var animated = "Card-module--animated--oEpnK";
export var appeared = "Card-module--appeared--gwVHx";
export var footer = "Card-module--footer--bCpX8";
export var header = "Card-module--header--hx+WU";
export var inner = "Card-module--inner--xrySk";
export var root = "Card-module--root--mkutZ";
export var title = "Card-module--title--tleU2";
export var titleIcon = "Card-module--titleIcon--NxtjN";